<template>
    <div class="col_y time">
        <div class="header_wrap" @mousedown.left.prevent="action_MouseDown" @mouseup.left.prevent="action_MouseUp">
            <div class="title">시간</div>
        </div>
        <TimeItem v-for="(d, index) in calculatedTimeArray" :key="index" :timeData="d" :selectedAreaHelper="selectedAreaHelper" />
        <!-- 높이 조절 가이드 -->
        <TimeHeightGuide :scroll="scroll" />
    </div>
</template>

<script>
import { sheetState } from '../../../sheet-state'
import { closeHServiceSearch, hideCellMenu, hideReservationMenu } from '../../../sheet-overlays'
import { setTimeArray, sheetAxis } from '../../../sheet-axis'
import { sheetFilters } from '../../../sheet-filters'
import TimeItem from './TimeItem.vue'
import TimeHeightGuide from './TimeHeightGuide.vue'

import { timeHeight, getTimeHeight } from '../Time/time-height'

const moment = require('@/util/MPMoment')

export default {
    components: { TimeItem, TimeHeightGuide },
    props: {
        selectedAreaHelper: Object,
        scroll: HTMLDivElement
    },
    data() {
        return {
            sheetAxis,
            sheetFilters,
            timeHeight,

            timeArray: []
        }
    },
    watch: {
        timeArray: {
            immediate: true,
            handler: function (newValue) {
                setTimeArray(newValue)
                sheetAxis.sheetStartedAt = moment(this.reservationSheetStartTime)
                sheetAxis.sheetEndedAt = moment(this.reservationSheetEndTime)
            }
        },
        selectedDate: {
            deep: true,
            handler: function (newValue) {
                if (newValue == undefined) {
                    return
                }
                this.getTimeArray()
            }
        },
        todayTimeInfo: {
            deep: true,
            handler: function (newValue) {
                if (newValue == undefined) {
                    return
                }
                this.getTimeArray()
            }
        },
        timeInterval: {
            handler: function (newValue) {
                if (newValue == undefined) {
                    return
                }
                this.getTimeArray()
            }
        }
    },
    computed: {
        timeInterval: function () {
            return this.sheetAxis.selectedTimeInterval
        },
        reservationSheetTimeInfo: function () {
            return sheetState.reservationSetting?.possibleTimes ?? []
        },
        todayTimeInfo: function () {
            let today = moment(this.sheetAxis.selectedDate).startOf('days')
            let todayIndex = today.weekday()
            for (let i = 0; i < this.reservationSheetTimeInfo.length; i++) {
                let info = this.reservationSheetTimeInfo[i]
                if (info.index == todayIndex) {
                    return info
                }
            }
            return undefined
        },
        selectedDate: function () {
            return this.sheetAxis.selectedDate
        },
        reservationSheetStartTime: function () {
            return moment(this.todayTimeInfo?.startedAt).startOf('minutes')
        },
        reservationSheetEndTime: function () {
            return moment(this.todayTimeInfo?.endedAt).startOf('minutes')
        },
        calculatedTimeArray: function () {
            return this.sheetAxis.timeArray
        },
        selectedColumnCount: function () {
            let usableGroups = this.sheetFilters.usableGroups
            let count = 0
            usableGroups.forEach((g) => {
                count += g.columns?.length ?? 0
            })
            return count
        }
    },
    methods: {
        getTimeArray() {
            if (this.todayTimeInfo == undefined) {
                return
            }
            let hospitalID = this.hospital.selectedHospital._id
            let selectedDate = moment(this.selectedDate)
            this.timeArray = getTimeHeight(hospitalID, selectedDate)
        },
        action_MouseDown() {
            if (this.timeHeight.isResizing == true) {
                return
            }
            closeHServiceSearch()
            hideCellMenu()
            hideReservationMenu()
            this.selectedAreaHelper.setType(this.selectedAreaHelper.Type.all)
            this.selectedAreaHelper.setStartPoint(0, 0)
        },
        action_MouseUp() {
            if (this.timeHeight.isResizing == true) {
                return
            }
            if (this.selectedAreaHelper.currentType != this.selectedAreaHelper.Type.all) {
                return
            }
            this.selectedAreaHelper.setEndPoint(this.selectedColumnCount - 1, this.calculatedTimeArray.length - 1)
            let start = this.selectedAreaHelper.startPoint
            let end = this.selectedAreaHelper.endPoint
            this.selectedAreaHelper.setSelectedRange(start.x, start.y, end.x, end.y)
            this.selectedAreaHelper.clearStartEndPoint()
        }
    }
}
</script>
